import { createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from 'lodash';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const isLoggedIn = createDeepEqualSelector(
  state => state.app.get('isLoggedIn'),
  res => res
);
